<nav [attr.aria-label]="subtitle || 'Enlaces'">
  @if (subtitle) {
    <h6 class="inter-bold">{{ subtitle }}</h6>
  }
  <ul>
    @for (link of links; track link.redirectionUrl) {
      <li class="small">
        <a
          [href]="link.redirectionUrl"
          [rel]="link.isExternalLink ? 'noopener noreferrer' : null"
          [target]="link.isExternalLink ? '_blank' : null"
          [routerLink]="!link.isExternalLink ? link.redirectionUrl : null"
        >
          {{ link.text }}
        </a>
      </li>
    }
  </ul>
</nav>
